import { createFileRoute } from '@tanstack/react-router';
import { Edit } from '../../features/dossiers/dossier/edit/edit';
import {
  createObjectPermissionGuard,
  DOSSIER_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/vorgaenge/$dossierId_/bearbeiten')({
  component: Edit,
  beforeLoad: createObjectPermissionGuard(
    getPermissionSet(DOSSIER_PERMISSIONS, 'EDIT'),
    (params) => params.dossierId,
  ),
});

export const EditDossierRoute = Route;
